(() => {
  const MOBILE_QUERY = '(max-width: 1023px)';

  const patchSticky = () => {
    if (!window.Alpine?.$data) return false;

    const sticky = document.querySelector('[data-pdp-sticky]');
    const sentinel = document.querySelector('[data-native-atc-sentinel]');

    if (!sticky || !sentinel) return false;

    const data = window.Alpine.$data(sticky);
    if (!data || typeof data.updateViewportState !== 'function') return false;
    if (data.__fafReviewWindowPatched) return true;

    const originalUpdateViewportState = data.updateViewportState.bind(data);

    data.updateViewportState = function updateReviewViewportState() {
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        originalUpdateViewportState();
        return;
      }

      this.sentinel = this.sentinel || sentinel;
      if (!this.sentinel) {
        this.viewportVisible = false;
        return;
      }

      const rect = this.sentinel.getBoundingClientRect();
      const viewportHeight = Number(window.visualViewport?.height || window.innerHeight || 0);

      // Review behaviour on mobile:
      // - show while the native ATB is still below the viewport;
      // - hide as soon as the native ATB enters view;
      // - remain hidden after the customer scrolls beyond it.
      this.viewportVisible = rect.top >= viewportHeight;
    };

    data.__fafReviewWindowPatched = true;

    if (typeof data.observeSentinel === 'function') {
      data.observeSentinel();
    } else {
      data.updateViewportState();
    }

    return true;
  };

  const boot = () => {
    let attempts = 0;

    const tryPatch = () => {
      if (patchSticky()) return;
      attempts += 1;
      if (attempts < 90) window.requestAnimationFrame(tryPatch);
    };

    tryPatch();
  };

  document.addEventListener('alpine:initialized', boot, { once: true });
  window.addEventListener('load', boot, { once: true });

  if (document.readyState === 'complete') boot();
})(); 
